/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, February 11th 2022, 7:19:52 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

export enum DnDItemTypes {
  OS_TASK_TEMPLATE_ITEM = "OS_TASK_TEMPLATE_ITEM",
  OS_ADD_NEW_TASK_TEMPLATE = "OS_ADD_NEW_TASK_TEMPLATE",

  OS_FORM_FIELD_LIST_ITEM = "OS_FORM_FIELD_LIST_ITEM",
  OS_ADD_NEW_FORM_FIELD = "OS_ADD_NEW_FORM_FIELD",
}
